require.register("app/graphql/Query", function(exports, require, module){
  $0
  
});

